import styles from './DateTag.module.scss';

export const DateTag = ({ date }: { date: string }) => {
	return <button className={styles.DateTag}>{date}</button>;
};
